
















































































































































import Vue from "vue";
import Component from "vue-class-component";
import { EventInterface, ModpackInterface } from "@/types";
import { ModelSync, PropSync, Watch } from "vue-property-decorator";
import ModpackService from "@/classes/ModpackService";
import ModpackUploadDialog from "./ModpackUploadDialog.vue";

@Component({ components: { ModpackUploadDialog } })
export default class EventEditorInformation extends Vue {

  public get datetime() {
    const date = new Date(Date.parse(`${this.date}T${this.time}:00.000`));

    return date.toISOString();
  }

  public get localModpacks() {
    return this.modpacks.filter(() => true);
  }
  @PropSync("modpackCollection")
  public readonly modpacks!: ModpackInterface[];

  @ModelSync("eventValue", "input")
  public readonly event!: Partial<EventInterface>;

  public dateMenu: boolean = false;
  public timeMenu: boolean = false;
  public date: string = "";
  public time: string = "";

  public dialog: boolean = false;

  public uploading: boolean = false;

  public newModpack: File | null = null;

  public validationRules = {
    eventNameRules: [
      (value: string | undefined) => {
        if (value) { return true; }

        return "Event name is required.";
      },
      (value: string | undefined) => {
        if (value && value.length <= 65) { return true; }

        return "Event name must be 65 characters or less.";
      },
    ],
    eventDateRules: [
      (value: string) => {
        if (value) { return true; }

        return "Event date is required.";
      },
      (value: string) => {
        if (Date.parse(value) - Date.now() > 0) { return true; }

        return "Event date cannot be in the past.";
      },
    ],
    eventTimeRules: [
      (value: string) => {
        if (value) { return true; }

        return "Event time is required.";
      },
    ],
    eventDescriptionRules: [
      (value: string) => {
        if (value) { return true; }

        return "Event description is required.";
      },
    ],
    modpackRules: [
      (v: ModpackInterface | null) => !!v || "A modpack needs to be selected.",
    ],
  };

  public saveDate(date: string) {
    (this.$refs.dateMenu as any).save(date);
  }

  public saveMinutes(time: string) {
    (this.$refs.timeMenu as any).save(time);
  }

  public uploadModpack(modpack: number) {
    this.$emit("update-modpack", modpack);
  }

  @Watch("date")
  private dateChanged() {
    this.event.date = this.datetime;
  }

  @Watch("time")
  private timeChanged() {
    this.event.date = this.datetime;
  }
}
